import { computed, ref } from "vue";
import { defineStore } from "pinia";

export const useSettingsStore = defineStore("settings", () => {
  const dark = ref(false);
  const selectedPalette = ref({});
  const settings = ref({});
  const squareFootage = ref(1500);

  const colorPalettes = computed(() => settings.value?.colorPalettes || []);

  const computedPrice = computed(() => {
    const pricePerSquareFoot = 0.5;
    return Math.round(squareFootage.value * pricePerSquareFoot);
  });

  const menu = computed(() => settings.value?.menu || []);

  return {
    colorPalettes,
    computedPrice,
    dark,
    menu,
    selectedPalette,
    settings,
    squareFootage,
  };
});
